export enum STATUS_TYPE {
    IN_PROGRESS = 1,
    DONE = 2,
    EXPIRED = 3,
}
